export default __webpack_public_path__ + "static/media/12_Small_Chonky_White.b4e1a9d4.png";